import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MyTable, { TableRow } from "../../../components/MyTable";
import { moveColumnPaymentSlips, resetSlipsSort, searchEmployeePaySlips, setPaymentSlipsSort } from "../../../store/slices/documents";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "./downloadButtonDocument";
import { EMPLOYEE_PAYMENT_SLIPS_ONE, EMPLOYEE_PAYMENT_SLIPS_THREE, EMPLOYEE_PAYMENT_SLIPS_TWO, PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { useEffect, useState } from "react";
import { CardContent, Grid, Typography } from "@mui/material";
import { formatDateToTimestamp } from "../../../utils/date";

interface TablePaymentsSlipsProps {
    numberOfCards?: number;
    changeViewOptionHidden?: boolean;
    startDate?: Date;
    endDate?: Date;
    requestId: (typeof EMPLOYEE_PAYMENT_SLIPS_ONE | typeof EMPLOYEE_PAYMENT_SLIPS_TWO |  typeof EMPLOYEE_PAYMENT_SLIPS_THREE)

    status?: 0 | 1 | 2;

    hiddenBottomPaginator?: boolean;
    hiddenFilterOptions?: boolean;

    ruc?: string;
}

const TablePaymentSlips = ({requestId, hiddenFilterOptions, status, ruc, ...props}: TablePaymentsSlipsProps) => {
    const documents = useSelector((state: RootState) => state.documents[requestId]);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const [startDate, setStartDate] = useState<Date | null>(props.startDate || null);
    const [endDate, setEndDate] = useState<Date | null>(props.endDate || null);

    const MyButton = (headRow: TableHeadRows, row: TableRow<string, any>) => {
        return (
            <DownloadButtonDocument
                minWidth={"2rem"}
                FirmaTop={row.FirmaTop}
                NroFs={row.NroFS}
                FirmadoFecha={row.FirmadoFecha} 
                IdDocument={row.NroBoletaNomina}
                requestId={PAYMENT_SLIP_DOCUMENT_SIGNATURE_REQUEST}
                onSignDocument={() => 
                    dispatch(moveColumnPaymentSlips({
                        id: row.NroBoletaNomina, 
                        from: EMPLOYEE_PAYMENT_SLIPS_ONE, 
                        to: EMPLOYEE_PAYMENT_SLIPS_TWO
                    })
                )}
            />
        )
    }
    const employeeSlipsTableHeadRows = [
        {
            label: "Periodo",
            rowKeyName: "Periodo",
            buildOrderValue: (row: string) => {
                const value = row.split(" ").slice(1, 5).join("")
                console.log(value)
                return value
            },
            allowOrderAction: true,
        },{
            label: "Tipo de documento",
            rowKeyName: "TipoDocumento",
            allowOrderAction: true,
        },{
            label: "Fecha de envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fecha de firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: MyButton,
        }
    ,];
    

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        dispatch(resetSlipsSort(requestId));
        dispatch(searchEmployeePaySlips((status || 0), requestId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId]);

    return (
        <MyTable
            key="tab-0"
            hiddenFilterOptions={hiddenFilterOptions}
            calculateLimitDate={true}
            dateFilterField={'FechaEnviadoPortal'}
            tableHeadRows={employeeSlipsTableHeadRows}
            tableRows={documents.paymentSlips.filter(e => ruc === 'all' || e.RUC.trim() === ruc)}
            setOrderedData={(sortField: any, sortType: any, rowData: any) => dispatch(setPaymentSlipsSort({sortField, sortType, rowData, requestId}))}
            sortField={documents.paymentSlipsSortField}
            sortType={documents.paymentSlipsSort}
            loading={false}
            // loading={documents.paymentSlipsLoading}
            // firstSelectControlProps={hiddenFilterOptions ? undefined : {
            //     label: "Empresa",
            //     autocalculateFieldName: "DescripcionEmpresa"
            // }}
            selectControlProps={hiddenFilterOptions ? undefined : {
                label: "Tipo de documento",
                autocalculateFieldName: "TipoDocumento"
            }}
            rangeControlProps={{
                startDate: startDate,
                endDate: endDate,
                setEndDate: setEndDate,
                setStartDate: setStartDate,
            }}
            cardComponent={{
                cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" marginBottom=".2rem">
                                    {row.TipoDocumento}
                                    </Typography>
                                </Grid>
                                <Grid item maxWidth="2rem">
                                    {row.NroFS && MyButton(null as any, row)}
                                </Grid>
                            </Grid>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Empresa: {" "}
                                <Typography variant="body2" component="span">
                                    {row.DescripcionEmpresa}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Período: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Periodo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Enviado el: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Firmado el: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>
                        </CardContent>
                    );
                },
                numberOfCards: props?.numberOfCards,
                changeViewOptionHidden: props?.changeViewOptionHidden,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={props?.hiddenBottomPaginator}
        />
    )
}

export default TablePaymentSlips;